// @flow

export const checkProps = (required: Array<string>, props: Object, serializerName: string) => {
  for (let i = 0; i < required.length; i++) {
    if (typeof props[required[i]] === 'undefined') {
      throw new Error(`${required[i]} missing in serializer: ${serializerName}!!`)
    }
  }
}

export const checkHandles = (required: Array<string>, handles: { [name: string]: Function }, serializerName: string) => {
  for (let i = 0; i < required.length; i++) {
    if (typeof handles[required[i]] === 'undefined' || typeof handles[required[i]] !== 'function') {
      throw new Error(`${required[i]} missing in serializer: ${serializerName}!!`)
    }
  }
}
